import { render, staticRenderFns } from "./ShopPendingView.vue?vue&type=template&id=33a921fe&"
import script from "./ShopPendingView.vue?vue&type=script&lang=js&"
export * from "./ShopPendingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports